import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import SlideUpAnimation from "../../components/SlideUpAnimation/SlideUpAnimation";
import SchemaMarkup from "../../components/SchemaMarkup/SchemaMarkup";
import { getLang } from "../../features/app/appSlice";
import {
  conference0,
  conference1,
  conference4,
  conference5,
  conferenceSpeakers,
  logoStep,
} from "../../assets/imgExport";

const ARTICLE_TITLE = {
  en: "The New Vision Family Office Team Invited to Attend the STEP Alpine Conference 2026 in Switzerland",
  zh: "新愿景家族办公室团队受邀出席2026年瑞士STEP阿尔卑斯会议",
};
const ARTICLE_DATE = {
  en: "May 2026",
  zh: "2026年5月",
};
const ARTICLE_LOCATION = {
  en: "Interlaken, Switzerland",
  zh: "瑞士因特拉肯",
};
const ARTICLE_URL =
  "https://www.newvgroup.com/news/step-alpine-conference-2026";

const PARAGRAPHS: { en: string; zh: string }[] = [
  {
    en: "On 6–7 May, the New Vision Family Office team was invited to attend the STEP Alpine Conference 2026 in Interlaken, Switzerland. The event brought together leading professionals and institutional representatives from the global private wealth management, family office, trust, tax and legal sectors to discuss the latest developments in international wealth management and emerging opportunities in cross-border succession planning.",
    zh: "5月6、7两日，新愿景家族办公室团队受邀出席于瑞士因特拉肯举办的 STEP Alpine Conference 2026 国际行业峰会，与来自全球私人财富管理、家族办公室、信托、税务及法律领域的行业专家和机构代表齐聚一堂，共同探讨全球财富管理行业的发展趋势与跨境传承的新机遇。",
  },
  {
    en: "This year's conference was held at the renowned Congress Kursaal Interlaken, set between two lakes and surrounded by the Swiss Alps. Known for its striking scenery and rich cultural heritage, the venue provided an impressive setting for the summit. Its historic halls, modern conference facilities and the Kursaal gardens overlooking the Jungfrau created an atmosphere that combined professionalism with the distinctive charm of Switzerland, offering delegates from around the world an exceptional environment for discussion and exchange.",
    zh: "本届峰会于瑞士著名会议中心 Congress Kursaal Interlaken 举行。会场坐落于两湖之间，被阿尔卑斯群山环绕，拥有独具特色的自然景观与历史文化氛围。历史悠久的典雅大厅、现代化会议礼堂，以及可远眺少女峰（Jungfrau）的Kursaal花园，共同构成了此次峰会极具国际化与专业深度的交流场景，也为来自世界各地的参会嘉宾提供了高规格的交流体验。",
  },
  {
    en: "As one of the most influential gatherings in the international private wealth management sector, the STEP Alpine Conference attracted hundreds of industry professionals from nearly 50 countries and regions. Through keynote speeches, panel discussions, case studies and networking sessions, the conference explored some of the most significant issues currently shaping the global wealth management industry.",
    zh: "作为国际私人财富管理领域具有广泛影响力的行业盛会之一，本届 STEP Alpine Conference 吸引了数百位行业专业人士现场出席，参会嘉宾来自全球近50个国家和地区。峰会通过主题演讲、圆桌论坛、案例分享及行业交流等形式，围绕全球财富管理行业当前最受关注的议题展开深入讨论。",
  },
  {
    en: "According to the official agenda, this year's conference focused on themes including the development of trusts and family offices, changes in global regulation, and cross-border wealth succession. Discussions also covered subjects such as international transparency standards, family governance, reputation management and the evolving challenges of wealth succession, offering valuable insight into the future direction of the industry.",
    zh: "根据峰会官方议程，本届峰会重点聚焦信托与家族办公室发展、全球监管变化以及跨境财富传承等核心方向。与此同时，峰会亦围绕跨境信息透明化、家族治理、声誉管理及新时期财富传承挑战展开深入交流，为全球财富管理行业提供了具有前瞻性的专业视角。",
  },
  {
    en: "The conference also featured a distinguished group of speakers and representatives from leading professional institutions across Europe and other international jurisdictions. Many of the speakers have extensive experience in family offices, international trust structures, cross-border taxation, regulatory compliance and wealth succession, contributing practical expertise and informed perspectives throughout the event.",
    zh: "本届峰会汇聚了来自欧洲及全球多个司法辖区的资深行业专家与专业机构代表担任主讲嘉宾，多位嘉宾长期深耕家族办公室、国际信托架构、跨境税务、监管合规及财富传承等领域，其丰富的国际实务经验为峰会带来了极具价值的行业洞察。",
  },
  {
    en: "During the conference, the New Vision Family Office team engaged in in-depth discussions with peers from different countries and regions on topics including the changing needs of global high-net-worth clients, cross-border asset management, international family governance structures and modern approaches to wealth succession. Through exchanges with internationally recognised institutions, the team further broadened its global perspective and gained valuable experience to support the continued enhancement of its client services.",
    zh: "峰会期间，新愿景家族办公室团队围绕全球高净值客户需求变化、跨境资产管理、国际家族治理架构以及新时代财富传承理念等方向，与来自不同国家和地区的行业同仁展开深入交流。通过与国际领先机构的互动沟通，团队进一步拓展了全球化视野，也为未来持续提升客户服务能力积累了宝贵经验。",
  },
  {
    en: "New Vision Family Office remains committed to the principles of international perspective, professional excellence and long-term value creation. The firm provides high-net-worth families with integrated services covering wealth planning, asset allocation, family governance, identity planning and succession arrangements. Its invitation to participate in the STEP Alpine Conference reflects growing international recognition of the firm's professional capabilities and service philosophy, while also demonstrating its continued commitment to engaging with the global wealth management community and strengthening international collaboration.",
    zh: "新愿景家族办公室始终坚持以国际化、专业化和长期主义为核心理念，致力于为高净值家族客户提供涵盖财富规划、资产配置、家族治理、身份规划及传承安排等在内的一站式综合服务。此次受邀参加 STEP Alpine Conference，不仅体现了国际行业对新愿景专业能力与服务理念的认可，也进一步彰显了团队持续融入全球财富管理生态、积极推动国际交流合作的发展方向。",
  },
  {
    en: "It is also worth noting that STEP (Society of Trust and Estate Practitioners) is widely regarded as one of the world's leading professional organisations in the fields of trusts, inheritance and family wealth succession. STEP has long played an important role in advancing professional standards and supporting practitioners specialising in trusts, estate planning and succession matters. Today, the organisation connects professionals across 96 countries and regions, including lawyers, accountants, tax advisers, trust specialists, financial consultants and family office professionals, making it one of the largest and most influential international organisations within the trust and wealth succession industry.",
    zh: "值得关注的是，STEP（Society of Trust and Estate Practitioners）作为全球信托、继承及家族财富传承领域最具权威性的国际专业组织之一，在全球财富管理行业拥有极高影响力。STEP 长期专注于信托、遗产规划及家族财富传承领域专业人士的发展与行业标准建设，目前已连接全球96个国家和地区，成员涵盖国际律师、会计师、税务顾问、信托专家、金融顾问及家族办公室专业人士等核心行业力量，是目前全球规模最大、最具国际影响力的信托与财富传承专业组织之一。",
  },
  {
    en: "Looking ahead, as a STEP member, the New Vision Family Office team will continue to strengthen collaboration with professional institutions worldwide, remain closely engaged with developments in the international wealth management sector, and further enhance its ability to provide professional, stable and globally minded services. Through these efforts, the firm aims to create lasting value for clients and support the sustainable growth and succession of family wealth.",
    zh: "未来，新愿景家族办公室团队作为STEP的会员之一，将继续加强与全球专业机构的交流合作，持续关注国际财富管理行业的最新趋势，以更加专业、稳健和全球化的服务能力，为客户创造长期价值，助力家族财富实现可持续传承与发展。",
  },
];

const KEY_SESSIONS = [
  {
    en: "Single Family Offices – The Hidden Champions of the Swiss Financial Industry",
    zh: "单一家族办公室——瑞士金融行业中的隐形冠军",
  },
  {
    en: "Trust Investments: Traps for Trustees",
    zh: "信托投资中的受托人风险",
  },
  {
    en: "Trust Law Update",
    zh: "信托法律更新",
  },
  {
    en: "Swiss Trustee Regulation",
    zh: "瑞士受托人监管实践",
  },
  {
    en: "Families: Origins of Conflict and Mechanisms of Resolving Conflicts Within Them",
    zh: "家族冲突的形成与解决机制",
  },
  {
    en: "Private Dispute Resolution: Arbitration and Mediation for Families and Trustees",
    zh: "家族及受托人争议解决中的仲裁与调解",
  },
];

const FACTS = [
  {
    label: { en: "Date", zh: "日期" },
    value: { en: "6–7 May 2026", zh: "2026年5月6-7日" },
  },
  {
    label: { en: "Venue", zh: "地点" },
    value: {
      en: "Congress Kursaal Interlaken, Switzerland",
      zh: "瑞士因特拉肯会议中心（Congress Kursaal Interlaken）",
    },
  },
  {
    label: { en: "Delegates", zh: "与会人数" },
    value: {
      en: "Hundreds of professionals from ~50 countries",
      zh: "约50个国家和地区的数百名专业人士",
    },
  },
  {
    label: { en: "Organiser", zh: "主办方" },
    value: {
      en: "STEP (Society of Trust and Estate Practitioners)",
      zh: "STEP（信托及遗产规划师协会）",
    },
  },
];

export default function StepAlpine2026Page() {
  const lang = false; // lang is true for EN, false for ZH
  const locale = lang ? "en" : "zh";

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: ARTICLE_TITLE[locale],
    datePublished: "2026-05-08",
    dateModified: "2026-05-08",
    inLanguage: lang ? "en" : "zh",
    articleSection: lang ? "News" : "新闻",
    url: ARTICLE_URL,
    image: ["https://www.newvgroup.com/logo512.png"],
    author: {
      "@type": "Organization",
      name: "New Vision International Group",
      url: "https://www.newvgroup.com",
    },
    publisher: {
      "@type": "Organization",
      name: "New Vision International Group",
      logo: {
        "@type": "ImageObject",
        url: "https://www.newvgroup.com/logo192.png",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": ARTICLE_URL,
    },
    keywords: lang
      ? [
          "STEP Alpine Conference 2026",
          "Interlaken",
          "Switzerland",
          "Family Office",
          "Trusts",
          "Wealth Succession",
          "New Vision Family Office",
        ]
      : [
          "STEP 阿尔卑斯会议 2026",
          "因特拉肯",
          "瑞士",
          "家族办公室",
          "信托",
          "财富传承",
          "新愿景家族办公室",
        ],
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: lang ? "Home" : "首页",
        item: "https://www.newvgroup.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: lang ? "News" : "新闻",
        item: "https://www.newvgroup.com/news",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: ARTICLE_TITLE[locale],
        item: ARTICLE_URL,
      },
    ],
  };

  return (
    <div className="bg-white">
      <SchemaMarkup data={[articleSchema, breadcrumbSchema]} />

      {/* HERO */}
      <div className="relative ">
        <img
          className="h-[480px] sm:h-[560px] w-full object-cover object-center"
          src={conference0}
          alt={
            lang
              ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
              : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
          }
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/55 to-black/85"></div>
        <div className="absolute inset-0 flex items-end">
          <div className="content-container w-full px-4 sm:px-8 md:px-12 lg:px-20 xl:px-36 py-10 sm:py-14 md:py-20 mx-auto">
            <SlideUpAnimation triggerOnce={true}>
              <NavLink
                to="/"
                className="text-white/70 hover:text-white text-sm tracking-widest uppercase mb-6 inline-block"
              >
                ← {lang ? "Back to Home" : "返回首页"}
              </NavLink>
              <div className="flex items-center gap-3 mb-6">
                <span className="bg-white text-secondary-dark text-xs tracking-[0.2em] uppercase px-3 py-1 font-medium">
                  {lang ? "News & Insights" : "新闻与洞察"}
                </span>
                <span className="text-white/70 text-xs tracking-widest uppercase">
                  {ARTICLE_DATE[locale]} · {ARTICLE_LOCATION[locale]}
                </span>
              </div>
              <h1 className="text-white font-sans text-4xl mobile:text-5xl sm:text-6xl leading-tight max-w-[1000px]">
                {ARTICLE_TITLE[locale]}
              </h1>
            </SlideUpAnimation>
          </div>
        </div>
      </div>

      {/* META STRIP */}
      <div className="bg-secondary-light">
        <div className="content-container px-4 sm:px-8 md:px-12 lg:px-20 xl:px-36 py-4 sm:py-6 md:py-8 mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
            {FACTS.map((fact, i) => (
              <div key={i}>
                <p className="tag uppercase tracking-widest text-xs text-secondary-dark/60 mb-2">
                  {fact.label[locale]}
                </p>
                <p className="font-header text-base md:text-lg leading-snug text-secondary-dark">
                  {fact.value[locale]}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ARTICLE BODY */}
      <article className="content-container px-4 sm:px-8 md:px-12 lg:px-20 xl:px-36 py-10 sm:py-14 md:py-20 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          {/* Side rail */}
          <aside className="lg:col-span-3 order-2 lg:order-1 ">
            <div className="lg:sticky lg:top-32 border-t border-black pt-6">
              <p className="tag uppercase tracking-widest text-xs mb-4">
                {lang ? "About STEP" : "关于 STEP"}
              </p>
              <img
                src={logoStep}
                alt="STEP – Society of Trust and Estate Practitioners"
                className="h-12 object-contain mb-4 grayscale"
              />
              <p className="text-sm text-secondary-dark/80 leading-relaxed mb-6">
                {lang
                  ? "STEP is a leading global professional body connecting practitioners across 96 countries in trusts, estate planning and family wealth succession."
                  : "STEP 是全球领先的信托、遗产规划和家族财富传承专业机构，连接 96 个国家和地区的从业者。"}
              </p>
              <a
                href="https://www.step.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-hollow-sm inline-block text-sm font-medium"
              >
                {lang ? "Visit STEP" : "访问 STEP"}
              </a>
            </div>
          </aside>

          {/* Body */}
          <div className="lg:col-span-9 order-1 lg:order-2">
            <SlideUpAnimation triggerOnce={true}>
              <p className="font-header text-2xl sm:text-3xl leading-snug text-secondary-dark mb-12">
                {lang
                  ? "The New Vision Family Office team joined leading professionals from nearly 50 countries at the STEP Alpine Conference 2026 in Interlaken — a defining gathering for the global trust, family office and wealth succession community."
                  : "新愿景家族办公室团队与来自近50个国家的业界精英齐聚瑞士因特拉肯，参加2026年STEP阿尔卑斯会议——全球信托、家族办公室与财富传承领域的重要盛会。"}
              </p>
            </SlideUpAnimation>
            <img
              className="my-6 w-full max-w-[850px] mx-auto rounded-lg"
              src={conference1}
              alt={
                lang
                  ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
                  : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
              }
            />
            <div className="space-y-6 text-secondary-dark leading-8 text-[15px]">
              {PARAGRAPHS.slice(0, 3).map((p, i) => (
                <p key={`p1-${i}`}>{p[locale]}</p>
              ))}
            </div>
            {/* Pull quote */}
            <SlideUpAnimation triggerOnce={true}>
              <blockquote className="my-14 border-l-2 border-main pl-6 sm:pl-8 py-2">
                <p className="font-header text-xl sm:text-2xl leading-relaxed text-secondary-dark">
                  {lang
                    ? "Set between two lakes and surrounded by the Swiss Alps, the Congress Kursaal Interlaken combined professionalism with the distinctive charm of Switzerland — an exceptional setting for delegates from around the world."
                    : "会议中心坐落于两湖之间，阿尔卑斯山环绕，因特拉肯会议中心将专业与瑞士独特魅力融合，为来自世界各地的嘉宾提供了卓越的交流场所。"}
                </p>
              </blockquote>
            </SlideUpAnimation>
            <img
              className="my-6 w-full max-w-[850px] mx-auto rounded-lg"
              src={conference4}
              alt={
                lang
                  ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
                  : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
              }
            />
            <div className="space-y-6 text-secondary-dark leading-8 text-[15px]">
              {PARAGRAPHS.slice(3, 4).map((p, i) => (
                <p key={`p2-${i}`}>{p[locale]}</p>
              ))}
            </div>

            {/* Key sessions */}
            <div className="my-14">
              <p className="tag uppercase tracking-widest text-xs mb-3">
                {lang ? "Key Sessions" : "重要议题"}
              </p>
              <h2 className="font-header text-2xl sm:text-3xl mb-8 border-t border-black pt-6">
                {lang ? "Highlights from the Agenda" : "议程亮点"}
              </h2>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
                {KEY_SESSIONS.map((s, i) => (
                  <li
                    key={`s-${i}`}
                    className="flex gap-4 text-secondary-dark leading-relaxed"
                  >
                    <span className="font-sans text-main text-xl shrink-0 w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-[15px]">{s[locale]}</span>
                  </li>
                ))}
              </ul>
            </div>
            <img
              className="my-6 w-full max-w-[850px] mx-auto rounded-lg"
              src={conferenceSpeakers}
              alt={
                lang
                  ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
                  : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
              }
            />
            <div className="space-y-6 text-secondary-dark leading-8 text-[15px]">
              {PARAGRAPHS.slice(4, 7).map((p, i) => (
                <p key={`p3-${i}`}>{p[locale]}</p>
              ))}
            </div>
            <img
              className="my-6 w-full max-w-[850px] mx-auto rounded-lg"
              src={conference5}
              alt={
                lang
                  ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
                  : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
              }
            />

            {/* About STEP block */}
            <SlideUpAnimation triggerOnce={true}>
              <div className="my-14 bg-main-light-blue p-6 sm:p-10 border-l-2 border-main rounded-lg">
                <p className="tag uppercase tracking-widest text-xs mb-3">
                  {lang ? "About STEP" : "关于 STEP"}
                </p>
                <p className="text-secondary-dark leading-8 text-[15px]">
                  {PARAGRAPHS[7][locale]}
                </p>
              </div>
            </SlideUpAnimation>

            <div className="space-y-6 text-secondary-dark leading-8 text-[15px]">
              <p>{PARAGRAPHS[8][locale]}</p>
            </div>

            {/* Footer / share */}
            <div className="mt-16 pt-8 border-t border-black flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <p className="tag uppercase tracking-widest text-xs text-secondary-dark/60">
                  {lang ? "Published" : "发布日期"}
                </p>
                <p className="font-header text-lg">{ARTICLE_DATE[locale]}</p>
              </div>
              <div className="flex gap-3">
                <NavLink
                  to="/business/family-office"
                  className="btn-hollow-sm text-sm font-medium"
                >
                  {lang ? "Family Office" : "家族办公室"}
                </NavLink>
                <NavLink
                  to="/contact"
                  className="btn-hollow-sm text-sm font-medium"
                >
                  {lang ? "Get in Touch" : "联系我们"}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  );
}
